import React, { memo } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  return <section className="bg-navy-900 text-cream-50 pt-16 pb-20 md:pt-24 md:pb-32 px-6 overflow-hidden" data-id="element-90">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-91">
        <div className="order-2 md:order-1" data-id="element-92">
          <FadeIn data-id="element-93">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-cream-50" data-id="element-94">
              Recupere la agilidad de su mente y proteja su independencia para
              siempre
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-95">
            <h2 className="text-xl md:text-2xl text-gold-400 font-medium mb-8 leading-relaxed" data-id="element-96">
              El método de neuro-activación diseñado para mujeres que se niegan
              a olvidar y quieren mantener el control total de su vida.
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-97">
            <div className="space-y-6 text-lg md:text-xl text-cream-100/90 leading-relaxed mb-10" data-id="element-98">
              <p data-id="element-99">
                Usted entra a una habitación y, de repente, se detiene. Se queda
                mirando la pared preguntándose: "¿A qué vine?". Esa pequeña
                punzada de miedo en el pecho no es por el olvido en sí, sino por
                lo que teme que signifique.
              </p>
              <p data-id="element-100">
                No es solo una palabra que se escapa o unas llaves perdidas. Es
                el temor silencioso de depender de los demás, de perder su
                autonomía o de dejar de ser la mujer vibrante y lúcida que
                siempre ha sido.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-101">
            <CTAButton showTrustBadges={true} data-id="element-102" />
          </FadeIn>
        </div>

        <div className="order-1 md:order-2 flex justify-center relative" data-id="element-103">
          <FadeIn delay={0.3} className="relative z-10 w-full max-w-md" data-id="element-104">
            {/* Decorative glow behind image */}
            <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform scale-90" data-id="element-105"></div>
            <img src="https://cdn.magicpatterns.com/uploads/nqLwK3okr5tkKjAmQYwVgL/imagen_memoria_blindada_1.png" alt="Tableta mostrando la portada del libro Memoria Blindada" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-106" />
          </FadeIn>
        </div>
      </div>
    </section>;
}